import { objectId } from "@redotech/rpc/ext";
import * as z from "zod";

export const recordRescuePanelCtaClicked = {
  name: "recordRescuePanelCtaClicked" as const,
  input: z.object({ treatmentId: objectId() }),
  output: z.void(),
};
